/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryResponse, UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserPathParams } from "../models/UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUser";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { usersAuthzAPIAdminPermissionsReadGetPermissionsOfUser } from "../axios/usersAuthzAPIAdminPermissionsReadGetPermissionsOfUser";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const usersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryKey = (userId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserPathParams["userId"]) => ["users-authz-api", { url: '/admin/user/:userId/permissions', params: {userId:userId} }] as const

export type UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryKey = ReturnType<typeof usersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryKey>

export function usersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryOptions(userId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserPathParams["userId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = usersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryKey(userId)
  return queryOptions<UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryResponse, ResponseErrorConfig<Error>, UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryResponse, typeof queryKey>({
   enabled: !!(userId),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return usersAuthzAPIAdminPermissionsReadGetPermissionsOfUser(userId, config)
   },
  })
}

/**
 * @summary Get all permissions for a specific user
 * {@link /admin/user/:userId/permissions}
 */
export function useUsersAuthzAPIAdminPermissionsReadGetPermissionsOfUser<TData = UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryResponse, TQueryData = UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryResponse, TQueryKey extends QueryKey = UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryKey>(userId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserPathParams["userId"], options: 
{
  query?: Partial<QueryObserverOptions<UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? usersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryKey(userId)

  const query = useQuery({
   ...usersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryOptions(userId, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}